import * as React from 'react';

function SvgCheckCircleSolid(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        d="M12 0a12 12 0 110 24 12 12 0 010-24zm6.22 6l-9.06 8.63-3.38-3.22L4 13.08 9.16 18 20 7.67 18.22 6z"
      />
    </svg>
  );
}

export default SvgCheckCircleSolid;
